import { createSelector } from '@reduxjs/toolkit';
export const manualNumericFacetSelector = createSelector((state, facetId) => state.manualNumericFacetSet[facetId]?.manualRange, (manualRange) => manualRange);
